// Package imports:
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
// Style imports:
// import './RelevantNews.scss';
// Component imports:
import Table from 'react-bootstrap/Table';
// Service imports:
import { formatDate } from '../../services/utils';
// Action imports:
import { setSelectedTick } from '../../redux-store/actions/dashboardActions';
// Type imports:
import { RootState } from '../../redux-store/reducers';

interface IOwnProps {
    symbol: string
};
type ReduxProps = ConnectedProps<typeof connector>
type Props = ReduxProps & IOwnProps;

interface IState {};

class RelevantNews extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    getNewsRows = () => {
        const { newsDoubleMap, currentTradingDay, symbol, selectedTick, setSelectedTick } = this.props;
        const newsTickData = newsDoubleMap?.[symbol]?.[currentTradingDay];
        if (newsTickData === undefined || newsTickData === 'waiting') {
            return (
                <tr className='NoClick'>
                    <td className='text-left' colSpan={2}>Loading...</td>
                </tr>
            );
        }

        if (newsTickData instanceof Error) {
            return (
                <tr className='NoClick text-left'>
                    <td className='text-left' colSpan={2}>Error: {newsTickData.message}</td>
                </tr>
            );
        }
        if (Array.isArray(newsTickData) && newsTickData.length === 0) {
            return (
                <tr className='NoClick text-left'>
                    <td className='text-left EmptyTableText' colSpan={2}>No news</td>
                </tr>
            );
        }

        const jsxRows = Array.isArray(newsTickData) ? newsTickData.map((newsTick) => (
            <tr
                key={newsTick.id}
                className={(selectedTick === newsTick) ? 'current' : undefined}
                onClick={() => setSelectedTick(newsTick)}
            >
                <td>
                    {formatDate(newsTick.timestamp, true, false)}
                </td>
                <td className='text-left'>
                    <a rel='noopener noreferrer' target='_blank' href={newsTick.link}>
                        {newsTick.title}
                    </a>
                </td>
            </tr>
        )): [];
        return Array.isArray(newsTickData) ? jsxRows : null;
    }

    render () {
        return (
            <div id='RelevantNews'>
                <h4>Relevant News</h4>
                <Table className='CompressedTable ClickableRows'>
                    <thead>
                        <tr>
                            <th scope='col'>Timestamp</th>
                            <th scope='col' className='text-left'>Title</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.getNewsRows()}
                    </tbody>
                </Table>
            </div>
        );
    }
}

function mapStateToProps({ newsReducer, dashboardReducer }: RootState) {
    const { newsDoubleMap } = newsReducer;
    const { currentTradingDay, selectedTick } = dashboardReducer;
    return {
        newsDoubleMap,
        currentTradingDay,
        selectedTick
    };
}

const connector = connect(mapStateToProps, { setSelectedTick });
export default connector(RelevantNews);
